import { NAME } from './constants';

export const getDomainState = (state) => state[NAME];
